import {typeEvent, initFields} from './events-dates';

(($) => {
    'use strict'

    const createEventForm = $('#create-event-form');
    if(createEventForm.length === 0) {
        return;
    }

    const daterangepickerLocale = {
        format: 'DD/MM/YYYY H:mm',
        cancelLabel: 'Annuler',
        applyLabel: 'Appliquer',
        fromLabel: 'Du',
        toLabel: 'Au',
    };

    typeEvent();
    calendar();

    $('#add-dates').on('click', function (e) {

        $('#duplicate-dates').append($('#dates').html());

        let numberEvent = $('.event_number').length;
        $('#duplicate-dates #duplicate-date').attr('id', 'duplicate-date_' + numberEvent);
        $('#duplicate-date_' + numberEvent + ' .event_number').html('#'+numberEvent);

        $('#duplicate-date_' + numberEvent + ' .btn-remove').append(`
               <div class="col-auto">
                   <div class="align-items-end mr-2">
                       <i  role="button"
                           id="class-modal-` + numberEvent + `"
                           data-id="` + numberEvent + `"
                           class="pointer remove far fa-times-circle text-danger">
                       </i>
                   </div>
               </div>`);

        // addEventListener for the current occurrence created
        $("i[id^='class-modal-']").on('click', function (e) {
            $('#modal-remove-occurrence').modal('show');
            document.querySelector('#modal-remove-occurrence #remove-occurrence').dataset.id = e.target.dataset.id;
        });

        initFields(numberEvent);

        $('#event_dates_' + numberEvent).daterangepicker({
            opens: 'right',
            showDropdowns: true,
            autoApply: true,
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 15,
            locale: daterangepickerLocale
        }).on('hide.daterangepicker', function (ev, picker) {
            let id = ev.target.dataset.id;
            $('#start_date_event_' + id).val(picker.startDate.format('YYYY-MM-DD'));
            $('#end_date_event_' + id).val(picker.endDate.format('YYYY-MM-DD'));
        });

        $('#single-date_' + numberEvent).daterangepicker({
            opens: 'right',
            showDropdowns: true,
            autoApply: true,
            singleDatePicker: true,
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 15,
            locale: daterangepickerLocale
        }).on('hide.daterangepicker', function (ev, picker) {
            let id = ev.target.dataset.id;
            $('#date_' + id).val(picker.startDate.format('YYYY-MM-DD H:mm'));
        });

        typeEvent();
    });

    $('#remove-occurrence').on('click', function (e) {
        $('#duplicate-date_' + e.target.dataset.id).remove();

        $("div[id^='duplicate-date_'] .event_number").each(function (i, e) {
            var number = i + 2;
            $(e).attr('id', 'duplicate-date_' + number);
            $(e).html(number);
        });

        $('#modal-remove-occurrence').modal('hide');
    });

    function calendar() {
        $(document).ready(function () {
            $('input[name="daterange[]"]').daterangepicker({
                opens: 'right',
                showDropdowns: true,
                timePicker: true,
                autoApply: true,
                startDate: moment().startOf('day'),
                endDate: moment().endOf('day'),
                timePicker24Hour: true,
                locale: {
                    format: 'DD/MM/YYYY H:mm',
                    cancelLabel: 'Annuler',
                    applyLabel: 'Appliquer',
                    fromLabel: 'Du',
                    toLabel: 'Au',
                }
            }).on('hide.daterangepicker', function (ev, picker) {
                let id = ev.target.dataset.id;
                $('#start_date_event_' + id).val(picker.startDate.format('YYYY-MM-DD H:mm'));
                $('#end_date_event_' + id).val(picker.endDate.format('YYYY-MM-DD H:mm'));
            });

            $('#start_date_event_1').val(moment().startOf('day').format('YYYY-MM-DD H:mm'));
            $('#end_date_event_1').val(moment().endOf('day').format('YYYY-MM-DD H:mm'));

            $('input[name="single-daterange[]"]').daterangepicker({
                opens: 'right',
                showDropdowns: true,
                autoApply: true,
                singleDatePicker: true,
                startDate: moment().startOf('day'),
                timePicker: true,
                timePicker24Hour: true,
                timePickerIncrement: 15,
                locale: {
                    format: 'DD/MM/YYYY H:mm'
                }
            }).on('hide.daterangepicker', function (ev, picker) {
                let id = ev.target.dataset.id;
                $('#date_' + id).val(picker.startDate.format('YYYY-MM-DD H:mm'));
            });

            $('#date_1').val(moment().startOf('day').format('YYYY-MM-DD H:mm'));
        });
    }
})($);
